import React, { FunctionComponent } from 'react'
import styles from "../../styles/FeaturesHomePage.module.scss"
import InfoSection from "./InfoSectionTS";

export type HomeFeature =  {
    lightBg: boolean,
    lightTopLine: boolean,
    lightText: boolean,
    lightTextDesc: boolean,
    textAlign: string,
    topLine: string,
    headline: string,
    description: string,
    hasLogo: boolean,
    imgStart: string,
    img: string,
    alt: string,
    start: string,
    clickableImg: boolean,
  }

  export type HomeFeatureProps = {
    features: HomeFeature[],
    title: string
  }
  


const GenericFeaturesHomePage: FunctionComponent<HomeFeatureProps> = ({features, title}) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleContent}>
        <h1>Features</h1>
        <h2>{title}</h2>
      </div>
      {
        features.map((feature) => {
          return <InfoSection {...feature} transparentBg={true} key={feature.headline}/>
        })
      }
    </div>
  )
}

export default GenericFeaturesHomePage